module.exports = __webpack_public_path__ + "img/IMG_9906.f7b809cd.jpeg";